/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, {  useRef } from 'react';
import {
    string, object, arrayOf, array, func, shape, bool,
} from 'prop-types';
import { makeStyles } from '@material-ui/core';
import AddonsUI from './AddonsUI';
import useSSRMediaQuery from '../../../../helpers/hooks/useSSRMediaQuery';
import WrapUpUI from './WrapUpUI';

const useStyle = makeStyles(() => ({
    desktopWrapper: {
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gridColumnGap: '16px',
        '@media screen and (max-width: 766px)': {
            gridTemplateColumns: 'repeat(4, 1fr)',
        },
        '@media screen and (max-width: 600px)': {
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        '@media screen and (max-width: 400px)': {
            gridColumnGap: '12px',
        },
    },
}));
const SliderAddon = ({
    content, handleOpenModal,
    selectedItems,
    addOnHoverInfo,
    getSelectAddonsByGroup, addOnData, isWrap,
    selectItems,
    removeItems, wrapupAddonRedesign,
}) => {
    const sliderRef = useRef(null);
    const classes = useStyle();
    const deviceType = useSSRMediaQuery();
    const renderProduct = () => (
        content.map((data) => {
            if (data.addons !== null) {
                const selectedGroupId = getSelectAddonsByGroup(data);

                return (
                    <AddonsUI
                        key={data.id}
                        addonData={data}
                        handleOpenModal={handleOpenModal}
                        selectedItems={selectedItems}
                        selectedGroupId={selectedGroupId}
                        addOnHoverInfo={addOnHoverInfo}
                        selectItems={selectItems}
                        isSlider
                        removeItems={removeItems}
                        wrapupAddonRedesign={wrapupAddonRedesign}
                    />
                );
            }
            return null;
        })
    );
    const renderWrapProduct = () => (
        content.map((wrapupData) => {
            if (wrapupData?.sku) {
                const selectedWrapupGroupId = getSelectAddonsByGroup(wrapupData, selectedItems);
                // If there is no addon data for one of the addon categories we do not render the addon header
                return (
                    <WrapUpUI
                        key={wrapupData?.sku?.id}
                        wrapUpData={wrapupData}
                        handleOpenModal={handleOpenModal}
                        selectedItems={selectedItems}
                        selectedGroupId={selectedWrapupGroupId}
                        addOnData={addOnData}
                        wrapUpInfo={addOnHoverInfo}
                        selectItems={selectItems}
                        isSlider
                        wrapupAddonRedesign={wrapupAddonRedesign}
                    />
                );
            }
            return null;
        })
    );
    return (
        <div className={classes.desktopWrapper}>
            {isWrap ? renderWrapProduct() : renderProduct()}
        </div>
    );
};

SliderAddon.propTypes = {
    content: array.isRequired,
    addOnHoverInfo: arrayOf(shape({
        info_on_hover: string,
        product_sku_part_numbers: string,
        see_more_info: string,
    })).isRequired,
    getSelectAddonsByGroup: func.isRequired,
    handleOpenModal: func.isRequired,
    selectedItems: object.isRequired,
    isWrap: bool,
    addOnData: array,
    selectItems: func.isRequired,
    removeItems: func,
    wrapupAddonRedesign: bool,
};
SliderAddon.defaultProps = {
    isWrap: false,
    addOnData: [],
    removeItems: () => {},
    wrapupAddonRedesign: false,
};
export default SliderAddon;
